// extracted by mini-css-extract-plugin
module.exports = {"OuterSVG":"LargePostsView_OuterSVG__kKcdP"};